// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23TFm","select":"styles_select__wl7jo"};